import cx from "classnames"
import { camelize } from "../../utils"
import type { IconColorsType } from "../"
export type IconProps = {
  color?: IconColorsType
  size?: 16 | 20 | 24 | 32
  contained?: boolean
  className?: string
}
const iconSource = "creditCardError"
const CreditCardErrorIcon = ({
  color,
  size = 24,
  contained = false,
  className,
}: IconProps) => {
  const computedClassName = cx(
    className,
    `cobalt-Icon cobalt-Icon--${iconSource}`,
    {
      [`c-fill-${camelize(color || "")}`]: color,
      "cobalt-Icon--size16": size === 16,
      "cobalt-Icon--size20": size === 20,
      "cobalt-Icon--size32": size === 32,
      "cobalt-Icon--contained": contained,
    },
  )
  return (
    <span className={computedClassName}>
      {
        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24">
          <title>{iconSource}</title>
          <path d="M22.956 16.061 20.038 18.978 22.956 21.894 21.894 22.956 18.978 20.039 16.06 22.956 15 21.894 17.916 18.978 15 16.06 16.06 15 18.979 17.916 21.895 15z" />
          <path
            fillRule="evenodd"
            d="M20.25 3.739C21.078 3.739 21.75 4.411 21.75 5.239V13.023L20.25 14.523V10.114H3.75V17.239H14.057L15.557 18.739H3.75L3.597 18.731C2.89 18.659 2.33 18.098 2.258 17.392L2.25 17.24V5.239C2.25 4.411 2.922 3.739 3.75 3.739zM3.75 8.614H20.25V5.239H3.75z"
            clipRule="evenodd"
          />
        </svg>
      }
    </span>
  )
}
export default CreditCardErrorIcon
